import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Download, Github } from 'lucide-react';
import { resumeData, profileData } from '../utils/mockData';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Resume = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const handleDownload = () => {
    window.open(`${API}/resume/download`, '_blank');
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.645, 0.045, 0.355, 1],
      },
    },
  };

  return (
    <section className="resume-section" id="resume">
      <div className="section-container">
        <motion.div
          ref={ref}
          variants={containerVariants}
          initial="hidden"
          animate={inView ? 'visible' : 'hidden'}
          className="resume-content"
        >
          {/* Section Header */}
          <motion.div variants={itemVariants} className="section-header">
            <h2 className="section-title">Resume</h2>
          </motion.div>

          {/* Profile */}
          <motion.div variants={itemVariants} className="resume-profile">
            <h3 className="subsection-title">Profile</h3>
            <p className="profile-text">{resumeData.profile}</p>
          </motion.div>

          {/* Core Capabilities */}
          <motion.div variants={itemVariants} className="resume-capabilities">
            <h3 className="subsection-title">Core capabilities</h3>
            <div className="capabilities-grid">
              {resumeData.capabilities.map((capability, index) => (
                <motion.div
                  key={index}
                  variants={itemVariants}
                  className="capability-card"
                  whileHover={{
                    y: -5,
                    transition: { duration: 0.2 },
                  }}
                >
                  <h4 className="capability-title">{capability.title}</h4>
                  <p className="capability-description">{capability.description}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Availability */}
          <motion.div variants={itemVariants} className="resume-availability">
            <p className="availability-text">{resumeData.availability}</p>
          </motion.div>

          {/* CTA Buttons */}
          <motion.div variants={itemVariants} className="resume-actions">
            <motion.button
              className="resume-button primary"
              onClick={handleDownload}
              whileHover={{ scale: 1.02, y: -2 }}
              whileTap={{ scale: 0.98 }}
              data-testid="resume-download-button"
            >
              <Download size={18} />
              Download Resume
            </motion.button>
            <motion.a
              href={profileData.github}
              target="_blank"
              rel="noopener noreferrer"
              className="resume-button secondary"
              whileHover={{ scale: 1.02, y: -2 }}
              whileTap={{ scale: 0.98 }}
              data-testid="resume-github-button"
            >
              <Github size={18} />
              View GitHub
            </motion.a>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Resume;
